import React, { useEffect } from "react"
import youtubePlay from "@/public/icons/youtube-play.svg"
import YouTube from "react-youtube"

const waitTimeForResetingIsClick = 500
const VideoWrapper = props => {
  const {
    videoId = "",
    thumb = "",
    height = "100%",
    width = 0,
    alt = "image",
    playThumb = false,
    onClick = () => {},
    getVideoInfo = () => {},
    index = 0,
    totalPdpImages = 0,
    zoomEntryPoint = "",
  } = props

  const addAnalyticsData = (type, event) => {
    const { adobeDataLayer: { getState } = {} } = window
    const { videoTitle = "", title = "" } = event?.target
    const videoName =
      type === "fullscreen" ? title.toLowerCase() : videoTitle.toLowerCase()
    const page = (getState && getState("page")) || {}
    const { imageSequence } = props
    const eventInfo = {
      eventAction: `pdp:product details:carousel image click:video ${type}`,
      eventName: `pdp:product details:carousel image click:video ${type}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: `video ${type}`,
      internalLinkPosition: "pdp",
      internalLinkType: `pdp:${
        zoomEntryPoint ? zoomEntryPoint : "video navigation"
      }`,
      internalLinkZoneName: `pdp:product details${
        totalPdpImages ? ":view gallery" : ""
      }`,
      internalLinkURL: "n/a",
      videoId,
      clickInternalLinks: "true",
      ...(imageSequence && { imageSequence }),
      videoName,
      imageSequence: `${index}_${totalPdpImages}`,
    }
    const { productInfo } = page

    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
      productInfo,
    })
  }

  const youtubePlayerPayload = {
    height,
    width,
    videoId,
    playerVars: {
      rel: 0,
      frameBorder: 0,
      allowFullScreen: true,
      autoPlay: 1,
    },
  }

  const videoFullScreenCallback = event => {
    if (window.isClick === true) {
      return
    }
    window.isClick = true
    setTimeout(() => {
      delete window.isClick
    }, waitTimeForResetingIsClick)

    if (
      document.webkitIsFullScreen ||
      document.mozFullScreen ||
      document.fullScreen
    ) {
      if (event.target.tagName === "IFRAME") {
        addAnalyticsData("fullscreen", event)
      }
    }
  }

  useEffect(() => {
    document.addEventListener("fullscreenchange", videoFullScreenCallback)
    document.addEventListener("webkitfullscreenchange", videoFullScreenCallback)
  }, [])

  const onReady = e => {
    getVideoInfo(e.target, index, videoId)
  }

  return thumb || playThumb ? (
    <>
      <img
        role="button"
        onClick={() => playThumb && onClick(videoId)}
        src={`https://i.ytimg.com/vi/${videoId}/${
          playThumb ? "mqdefault" : "default"
        }.jpg`}
        alt={alt}
        tabIndex={0}
        className="img-fluid"
      />
      {playThumb && (
        <img
          src={youtubePlay?.src}
          onClick={() => onClick(videoId)}
          className="img-play-button"
          alt={alt}
        />
      )}{" "}
    </>
  ) : (
    <YouTube
      videoId={videoId}
      opts={youtubePlayerPayload}
      onPlay={e => addAnalyticsData("play", e)}
      onEnd={e => addAnalyticsData("complete", e)}
      className={"pdp-image-reel__image-list pdp-image-reel__modal-image"}
      onReady={onReady}
    />
  )
}

export default VideoWrapper
